"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.probabilityResult = void 0;
var probabilityResult = function (probability) {
    if (probability <= 0) {
        return false;
    }
    if (probability >= 100) {
        return true;
    }
    var randomInt = Math.floor(Math.random() * 100) + 1;
    return randomInt <= probability;
};
exports.probabilityResult = probabilityResult;
